import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { AppMessageService } from '../../services/app-message/app-message.service';
import { CaseService } from '../../../pages/case/services/case.services';
import { SmsTemplateService } from '../../../pages/definition/sms-template/services/sms-template.service';
import { SmsTemplate } from '../../../pages/case/components/case-card/components/tab-header-components/case-send-sms/case-send-sms.component';
import { combineLatest, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectPatient } from '../../../pages/case/store/selectors/common-case.selector';
import { ApiService } from '../../services/api/api.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { selectPatientInformations } from '../../../pages/case/store/selectors/patient-informations.selector';

@Component({
  selector: 'app-payment-button',

  templateUrl: './payment-button.component.html',
  styleUrl: './payment-button.component.scss'
})
export class PaymentButtonComponent implements OnInit, OnDestroy {
  @Input() uuid: string | null= '';
  @Input() paymentId: number | null = null;

  availablePhones: string[] = [];
  filteredTemplates: SmsTemplate[] = [];
  selectedTemplate: SmsTemplate | null = null;
  patientPhones: string[] = [];
  selectedContent: string = '';
  selectedTemplateId: number | null;

  showPayment: boolean = false;
  paymentUrl: any;
  showDialog: boolean = false;
  selectedPhones: string[] = [];

  private subscription!: Subscription;

  constructor(
    private readonly smsTemplateService: SmsTemplateService,
    private readonly messageService: AppMessageService,
    private readonly store: Store,
    private readonly caseService: CaseService,
    private readonly apiService: ApiService,
    private readonly router: Router,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
     this.smsTemplateService.getAllFilter({}, {
      'filter.isActive': true,
      'filter.getAll':true

     }).subscribe({
      next: (res) => {
        const templates = res?.items ? res.items.filter( t => t.templateCode === 'sipay01' ) : [];
        this.filteredTemplates = templates;
        this.selectedTemplate = templates.length > 0 ? templates[0] : null;
        if (this.selectedTemplate) {
          this.availablePhones = [
            ...(this.selectedTemplate.toPhoneNumbers || []),
            ...this.patientPhones,
          ];

          this.selectedContent = this.selectedTemplate.content.replace('[Link]', `${window.location.origin}/payment/${this.uuid}`);
          this.selectedTemplateId = this.selectedTemplate.id;
        }
      },
    });

    this.subscription = combineLatest([this.store.select(selectPatientInformations)]).subscribe({
      next: ([patientInformations]) => {
       this.patientPhones =
            patientInformations?.contacts
              ?.filter((e) => e.phone)
              ?.map((i) => i.prefixValue + i.phone) ?? [];
      },
    });
  }

  onTemplateChange(event: Event) {
    this.selectedPhones = [];
    if (this.selectedTemplate) {
      this.availablePhones = [
        ...(this.selectedTemplate.toPhoneNumbers || []),
        ...this.patientPhones,
      ];

      this.selectedContent = this.selectedTemplate.content.replace('[Link]', `${window.location.origin}/payment/${this.uuid}`);
    } else {
      this.availablePhones = [];
      this.selectedPhones = [];
    }
  }

  isPhoneSelected(phone: string): boolean {
    return this.selectedPhones.includes(phone);
  }

  togglePhone(phone: string) {
    if (this.isPhoneSelected(phone)) {
      this.selectedPhones = this.selectedPhones.filter((p) => p !== phone);

    } else {
      this.selectedPhones = [...this.selectedPhones, phone];

    }
    if (this.selectedPhones.length > 0) {
      const lastIndex = this.selectedPhones.length - 1;
      this.selectedPhones[lastIndex] = this.selectedPhones[lastIndex].replaceAll(/\s+/g, '');
    }

  }

  sendSms() {
    if (this.selectedPhones.length === 0) {
      this.messageService.warningToast(
        '',
        'Lütfen en az bir telefon numarası seçiniz.'
      );
      return;
    }

    this.caseService
      .sendSms(this.selectedContent, this.selectedPhones, {templateId:this.selectedTemplateId,uid:this.uuid})
      .subscribe((res) => {
        this.showDialog = false;
        this.updateSmsStatus();
        this.messageService.successToast(
          '',
          'SMS gönderildi.'
        );
      });
  }

  private updateSmsStatus() {
    this.apiService.patch('payment/update-sms-status', { paymentId: this.paymentId }).subscribe(res => {});
  }

  handleChipAdd(event: any) {
    const phone = event.value.replaceAll(/\s+/g, ''); // tüm boşlukları sil
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      this.selectedPhones = this.selectedPhones.filter((p) => p !== phone);
    }
    if (this.selectedPhones.length > 0) {
      const lastIndex = this.selectedPhones.length - 1;
      this.selectedPhones[lastIndex] = this.selectedPhones[lastIndex].replaceAll(/\s+/g, '');
    }

  }


  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    this.unSub();
  }

  unSub() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.unSub();
  }

  openPaymentInDialog() {
    this.showPayment = true;
    const url = this.router.createUrlTree([
      'payment', this.uuid
    ]).toString();
    this.paymentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
